var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "form",
      class: [
        _vm.readerMode ? "process-form process-form-show" : "process-form",
      ],
      attrs: {
        "label-position": _vm.readerMode ? "left" : "top",
        rules: _vm.rules,
        model: _vm._value,
      },
    },
    [
      _vm._l(_vm.forms, function (item, index) {
        return [
          item.perm !== "H"
            ? [
                item.name !== "SpanLayout" && item.name !== "Description"
                  ? _c(
                      "el-form-item",
                      {
                        key: item.name + index,
                        class: _vm.setFormItemClass(item),
                        attrs: {
                          prop: item.id,
                          label: _vm.readerMode
                            ? item.title + "："
                            : item.title,
                        },
                      },
                      [
                        _c("form-design-render", {
                          ref: `sub-item_${item.id}`,
                          refInFor: true,
                          attrs: {
                            mode: "PC",
                            config: item,
                            userInfo: _vm.userInfo,
                            readerMode: _vm.readerMode,
                          },
                          on: { delInput: _vm.delInput },
                          model: {
                            value: _vm._value[item.id],
                            callback: function ($$v) {
                              _vm.$set(_vm._value, item.id, $$v)
                            },
                            expression: "_value[item.id]",
                          },
                        }),
                      ],
                      1
                    )
                  : [
                      _c("form-design-render", {
                        key: index,
                        ref: "span-layout",
                        refInFor: true,
                        attrs: {
                          mode: "PC",
                          config: item,
                          readerMode: _vm.readerMode,
                        },
                        model: {
                          value: _vm._value,
                          callback: function ($$v) {
                            _vm._value = $$v
                          },
                          expression: "_value",
                        },
                      }),
                    ],
              ]
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }